import { VariaveisAmbiente } from 'config';
import { ApiListSomatorioModel } from 'model/api/gestao/api-list-somatorio-model/api-list-model';
import { ComissaoPendenteModel } from 'model/api/gestao/comissao/comissao-pendente-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetComissaoPendente() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListSomatorioModel<ComissaoPendenteModel>>();

    const getComissaoPendente = useCallback(
        async (page: number, queryBusca: string) => {
            let queryPage = "";
            if (page) {
                queryPage = "page=" + page.toString();
            }
            const queryFinal = `${queryPage?.length > 0 || queryBusca?.length > 0 ? "?" : ""
                }${queryPage}${queryPage.length > 0 ? "&" : ""}${queryBusca}`;

            return invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/comissao/pendentes${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: true
            })
        }
        , [invocarApi]
    );
    return {
        ...outrasPropriedades,
        getComissaoPendente,
    };
}
